const { version } = require('../../../../package.json');

export const Version = () => {
  return <p className='version'>VERSION {version}</p>;
};
